import { logEvent } from "@/service/logs/log";

// Google wants a floating (naive) wall-clock time paired with ctz.
// Build it straight from the strings so it never depends on the
// clicker's browser timezone.
export const formatDateForGoogle = (dateStr: string, timeStr: string) => {
  return `${dateStr.replace(/-/g, "")}T${timeStr.replace(/:/g, "")}00`;
};

const WARSAW_TZ = "Europe/Warsaw";

// Format date for Outlook (ISO string)
export const formatDateForOutlook = (date) => {
  return encodeURIComponent(date.toISOString());
};

// Generate .ics file content
export const generateICS = (eventStart, eventEnd) => {
  const dtStamp =
    eventStart.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const dtStartStr =
    eventStart.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const dtEndStr =
    eventEnd.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";

  const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//YourProduct//YourApp//EN
BEGIN:VEVENT
UID:${Date.now()}@yourapp.com
DTSTAMP:${dtStamp}
DTSTART:${dtStartStr}
DTEND:${dtEndStr}
SUMMARY:${name}
END:VEVENT
END:VCALENDAR
`;

  return icsContent;
};

export function addToCalendarAction(
  option,
  data: {
    name: string;
    startDate: string;
    endDate: string;
    startTime: string;
    endTime: string;
    timeZone?: string;
  },
  logView: LogView,
  setOpen: (open: boolean) => void,
) {
  const { name, startDate, endDate, startTime, endTime } = data;

  logEvent("add_to_calendar", logView, {
    event_title: name,
    start_date: startDate,
    end_date: endDate,
    calendar_type: option,
  });

  const eventStart = new Date(`${startDate}T${startTime}:00`);
  const eventEnd = new Date(`${endDate}T${endTime}:00`);

  if (option === "Google") {
    const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(
      name,
    )}&dates=${formatDateForGoogle(startDate, startTime)}/${formatDateForGoogle(
      endDate,
      endTime,
    )}&ctz=${encodeURIComponent(WARSAW_TZ)}`;
    window.open(googleCalendarUrl, "_blank");
  } else if (option === "Outlook.com") {
    const outlookUrl = `https://outlook.live.com/owa/?path=/calendar/action/compose&subject=${encodeURIComponent(
      name,
    )}&startdt=${formatDateForOutlook(eventStart)}&enddt=${formatDateForOutlook(
      eventEnd,
    )}&allday=false`;
    window.open(outlookUrl, "_blank");
  } else if (option === "Microsoft365") {
    const outlookOfficeUrl = `https://outlook.office.com/calendar/0/deeplink/compose?subject=${encodeURIComponent(
      name,
    )}&startdt=${formatDateForOutlook(eventStart)}&enddt=${formatDateForOutlook(
      eventEnd,
    )}&allday=false&body=&location=&path=/calendar/action/compose&rru=addevent`;
    window.open(outlookOfficeUrl, "_blank");
  } else if (option === "Apple" || option === "iCal") {
    const icsContent = generateICS(eventStart, eventEnd);
    const blob = new Blob([icsContent], {
      type: "text/calendar;charset=utf-8",
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${name}.ics`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  setOpen(false);
}
